module.exports = __webpack_public_path__ + "static/don25-0b5a59cfe05b8d796da00be5058e977f.jpg";